import {createAsyncThunk} from '@reduxjs/toolkit';
import type {Persona} from '@Panels/persona-panel/persona-library';

export const savePersona = createAsyncThunk('savePersona', async ({persona, isSkipped}: {persona: Persona | null; isSkipped: boolean}) => {
  if (isSkipped || persona === null) {
    return window.PMW.writeLocal('user/skipPersonaDialogForUser');
  }

  return window.PMW.writeLocal('user/saveUserPersona', {idpersona: persona});
});

export const initTrialEligibility = createAsyncThunk('initTrialEligibility', async () => {
  return window.PMW.readLocal('premium/isUserEligibleForTrial');
});
